// Geolocation helper for the geofenced employee attendance feature.
//
// The backend enforces a geofence at sign-in / check-in for employee
// memberships (source_type === "EMPLOYEE"). Before calling login,
// verify-otp, /auth/me or logout we grab a FRESH device fix and send
// latitude / longitude. Admins / controllers / residents are never
// geofenced, but sending coordinates is harmless for them and keeps a
// single login path.
//
// getCoords never rejects: if the browser has no geolocation API, the user
// denies permission, or the fix times out, it resolves to
// { latitude: null, longitude: null }. The server then treats the caller as
// "outside" an enforced fence and blocks with a 403 the UI can retry.

const NO_COORDS = { latitude: null, longitude: null };

export const getCoords = () =>
    new Promise((resolve) => {
        if (typeof navigator === 'undefined' || !navigator.geolocation) {
            resolve(NO_COORDS);
            return;
        }
        navigator.geolocation.getCurrentPosition(
            (p) => resolve({
                latitude: p.coords.latitude,
                longitude: p.coords.longitude,
                // Extra key is ignored by callers that don't need it; the
                // attendance punch stores it as accuracy_meters.
                accuracy_meters: p.coords.accuracy != null ? Math.round(p.coords.accuracy) : null,
            }),
            () => resolve(NO_COORDS), // denied / unavailable / timeout
            { enableHighAccuracy: true, timeout: 10000, maximumAge: 0 }
        );
    });

// True when a backend 403 is a geofence rejection (vs. a permissions 403).
// Matches the two enforced-fence messages from the integration spec.
export const isGeofenceError = (message) =>
    typeof message === 'string' &&
    /society premises to (sign in|check in)/i.test(message);

export default getCoords;
